import React, {Component} from 'react';

class CertificateParameterItem extends Component {

  render() {
    return (
        <div className="certificate-entry-value">
          <span>{this.props.label}</span>
          <span>{this.props.value}</span>
        </div>
    );
  }
}

export default CertificateParameterItem;